import styled from '@emotion/styled';

export default styled('div')`
  color: #343434;
  font-size: 14px;
  padding: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
`;
